document.addEventListener('alpine:init', () => {
    // Runs after Alpine is loaded but before it's initialized on the page...

    console.log('alpine init');
});
